import "./Styles/main.scss";
import { Routes, Route } from "react-router-dom";
import PrivateRoute, {AuthRoute} from "./PrivateRoute";
import Auth from "./Pages/Auth";
import Card from "./Components/Card";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<AuthRoute path="/" element={<Auth />} />} />
        <Route exact path="/dashboard" element={<AuthRoute path="/dashboard" element={<Card />} />} />
      </Routes>
    </div>
  );
}

export default App;